import { render, staticRenderFns } from "./marketing-staff-details.vue?vue&type=template&id=29ebca36&"
import script from "./marketing-staff-details.vue?vue&type=script&lang=js&"
export * from "./marketing-staff-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports